import { useEffect, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { ApplyFormFieldValues } from 'pages/Apply/context';

import { RESIDENTIAL_STATUS_OWNER } from './constants';

export interface ResidentialFieldsHook {
  showRent: boolean;
  showMortgage: boolean;
}

export default function useResidentialFields(): ResidentialFieldsHook {
  const residentialStatus = useWatch<
    ApplyFormFieldValues,
    'credit.customer_details.residential_status'
  >({
    name: 'credit.customer_details.residential_status',
  });
  const { unregister } = useFormContext<ApplyFormFieldValues>();

  const showRent = useMemo(() => {
    if (!residentialStatus) return false;
    if (RESIDENTIAL_STATUS_OWNER.includes(residentialStatus)) return false;
    return true;
  }, [residentialStatus]);

  const showMortgage = useMemo(() => {
    if (!residentialStatus) return false;
    if (residentialStatus === 'owner') return true;
    return false;
  }, [residentialStatus]);

  useEffect(() => {
    if (showRent) return;
    unregister('credit.customer_details.monthly_rent_amount');
  }, [showRent, unregister]);

  useEffect(() => {
    if (showMortgage) return;
    unregister('monthly_mortgage_amount');
  }, [showMortgage, unregister]);

  return {
    showRent,
    showMortgage,
  };
}
